export default __webpack_public_path__ + "static/media/closed-view.f8d2ed52.JPG";